import { invalidateReportsP200} from 'modules/store/reportsP200';

export const invalidateReportP200 = () => dispatch => {
    dispatch(invalidateReportsP200());
};



// WEBPACK FOOTER //
// ./src/modules/reportP200.js